import { Modal } from 'antd';

/**
 * Popup lịch trận (cùng nguồn widget như C168), chỉ xem — không nhập tỷ số.
 */
export default function HotScheduleModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={520}
      title={
        <div className="text-center font-black uppercase tracking-wide text-[#111827] text-[15px] md:text-lg pr-2">
          Lịch thi đấu hot
        </div>
      }
      styles={{
        wrapper: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        content: {
          maxWidth: 'min(1000px, calc(100vw - 24px))',
          marginInline: 'auto',
          width: '100%'
        },
        body: { maxHeight: 'min(80vh, 600px)', overflowY: 'auto', paddingTop: 8 }
      }}
    >
      <div className="">
        <iframe
          src="https://football-widget.pages.dev/"
          width="100%"
          height="600"
          frameBorder="0"
          allowFullScreen
          title="Football Widget"
          className="w-full rounded-lg"
        />
      </div>
    </Modal>
  );
}
